import { render, staticRenderFns } from "./NbMainMenu.vue?vue&type=template&id=630cf31a&"
import script from "./NbMainMenu.vue?vue&type=script&lang=js&"
export * from "./NbMainMenu.vue?vue&type=script&lang=js&"
import style0 from "./NbMainMenu.vue?vue&type=style&index=0&id=630cf31a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports